import { useLocation } from "react-router-dom";

const Logo = () => {
  const location = useLocation();
  const isInteriorDesignPage =
    location.pathname.includes("interior-design") ||     location.pathname.includes("exterior-design") ||
    location.pathname === "/projects";
  // || location.pathname === "/";
  // Adjust based on your routing structure

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 1080"
        id="Layer_1"
        data-name="Layer 1"
        className="logo-small" // Keep the class for any other styles
      >
        <defs>
          <style>
            {`
              .cls-1 {
                font-family: Cinzel-Regular, Cinzel;
                font-size: 125.13px;
                fill: ${
                  isInteriorDesignPage ? "#FFF" : "#000"
                }; // Text color changes based on the page
              }
              .cls-logo {
                fill: ${
                  isInteriorDesignPage ? "#FFF" : "#000"
                }; // Logo color changes based on the page
              }
            `}
          </style>
        </defs>
        {/* Update all paths to have the cls-logo class */}
        <path
          className="cls-logo"
          d="M72.02,649.14h5.63c14.18,0,27.11-5.63,38.79-16.89,6.68-5.85,11.89-13.14,15.64-21.9l150.76-337.18c15.43-33.78,23.15-55.27,23.15-64.43h5.63l175.79,400.99c5.84,13.34,13.87,23.24,24.08,29.71,10.22,6.46,20.55,9.69,30.97,9.69h5v6.25h-140.75v-6.25h5.63c12.51,0,20.86-5.85,25.02-17.52.84-2.5,1.25-5.42,1.25-8.76s-1.04-7.51-3.13-12.51l-130.74-327.8-136.37,327.8c-1.66,5-2.5,9.9-2.5,14.7s2.19,10.01,6.57,15.64c4.38,5.63,10.95,8.45,19.7,8.45h5.63v6.25h-125.74v-6.25Z"
        />
        <path
          className="cls-logo"
          d="M963.46,655.73h-327.8v-5.63l262.74-414.13h-210.82c-10.43.42-19.19,4.17-26.27,11.26-7.1,7.1-10.63,15.85-10.63,26.27v11.26h-6.26v-78.82c6.26,2.5,17.3,5,33.16,7.51,15.84,2.5,30.23,3.75,43.16,3.75h173.91c20.43,0,36.07-1.14,46.92-3.44,10.84-2.29,17.3-3.85,19.39-4.69v5.63l-267.74,422.26h198.93c22.1,0,40.24-7.09,54.42-21.27,14.17-14.17,24.6-32.94,31.28-56.3h6.25l-20.64,96.34Z"
        />
        <path
          className="cls-logo"
          d="M95.88,270.72c-35.7,21.5-44.67,69.49-26.41,105.36,21.12,41.49,66.49,65.06,110.31,74.87,50.43,11.29,103.3,5.93,152.47-8.68,25.05-7.44,49.4-17.11,73.08-28.13,23.44-10.91,46.07-23.41,69.13-35.07,22.06-11.15,44.68-21.62,68.66-27.95,18.96-5,42.93-8.45,58.93,6.53,16.45,15.41,18.08,39.98,11.58,60.37-6.9,21.64-21.9,42.17-38.69,57.28-7.41,6.66-16.93,14.45-26.95,16.46-7.89,1.59-16.78-4.94-16.88-13.24-.05-3.95,2.15-7.83,5.25-10.18,1.26-.96,2.09-1.3,3.26-1.7-1.61.56,2.05.12.29.06,1.25.04,2.51-.03,3.78.12,11.88,1.41,22.96,8.68,33.71,13.45,45.07,19.98,93.66,30.69,142.72,34.3,49.91,3.67,100.34.04,149.63-8.21,24.92-4.17,49.65-9.46,74.13-15.74,23.91-6.14,50.57-12.48,66.61-32.85,6.66-8.46,10.12-18.59,9.19-29.35-.42-4.85-9.96-3.67-12.78-2.92-4.08,1.09-10.04,3.9-9.61,8.92.94,10.86-5,21.34-13.28,28.01s-19.1,9.84-29.28,12.64c-23.6,6.51-47.51,12.08-71.6,16.45-49.3,8.95-99.55,13.33-149.63,10.13-48.86-3.12-97.43-13.81-142.06-34.19-12.3-5.62-24.26-12.3-37.93-13.76-12.83-1.37-26.61,2.49-36.18,11.37-7.75,7.19-11.57,18.04-5.77,27.6,6.2,10.23,19.16,13.29,30.35,12.48,25.58-1.85,48.63-21.04,64.62-39.72s30.2-41.03,32.93-65.61c2.38-21.46-5.11-44.15-23.55-56.5-20.57-13.78-48.34-10.71-71.1-5.25-50.97,12.24-95.47,40.98-142.27,63.33-46.36,22.13-96.06,40.06-147.86,42.18-46.92,1.93-97.96-8.82-134.72-39.6-16.3-13.65-29.88-31.39-35.06-52.3-4.52-18.25-2.42-38.8,7.12-55.16,4.49-7.7,10.4-14.07,17.92-18.6,3.28-1.98,6.41-6.71,1.85-9.17s-11.66-.56-15.88,1.98h0Z"
        />
        <text className="cls-1" transform="translate(72.01 844.15)">
          <tspan x="0" y="0">
            Design Studio
          </tspan>
        </text>
      </svg>
    </div>
  );
};

export default Logo;
